/**
 * Cálculo PURO da posição do balão de tooltip (fixed, coords de viewport).
 * O balão é renderizado num portal no <body> — assim NUNCA é cortado pelo
 * container do sidebar (que tem overflow). Preferimos abrir à direita do "?";
 * se não couber, viramos para a esquerda; sempre grudado verticalmente no gatilho
 * e preso dentro da viewport (com margem).
 */
export interface Retangulo {
  left: number;
  right: number;
  top: number;
  bottom: number;
  width: number;
  height: number;
}
export interface PosicaoBalao {
  left: number;
  top: number;
  lado: 'right' | 'left';
}

const GAP = 8;
const MARGEM = 8;

export function posicaoTooltip(
  gatilho: Retangulo,
  balao: { width: number; height: number },
  viewport: { width: number; height: number },
  preferida: 'right' | 'left' = 'right',
): PosicaoBalao {
  const centroY = gatilho.top + gatilho.height / 2;
  let top = centroY - balao.height / 2;
  // Prende verticalmente dentro da viewport.
  top = Math.max(MARGEM, Math.min(top, viewport.height - balao.height - MARGEM));

  const cabeDireita = gatilho.right + GAP + balao.width + MARGEM <= viewport.width;
  const cabeEsquerda = gatilho.left - GAP - balao.width - MARGEM >= 0;
  // Usa a preferida se couber; senão o outro lado; se nenhum, o que tiver mais espaço.
  let lado: 'right' | 'left';
  if (preferida === 'right') lado = cabeDireita ? 'right' : cabeEsquerda ? 'left' : 'right';
  else lado = cabeEsquerda ? 'left' : cabeDireita ? 'right' : 'left';

  let left = lado === 'right' ? gatilho.right + GAP : gatilho.left - GAP - balao.width;
  // Prende horizontalmente (caso extremo: balão mais largo que o espaço).
  left = Math.max(MARGEM, Math.min(left, viewport.width - balao.width - MARGEM));
  return { left, top, lado };
}
